//PDFOS
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import dataHoraFormatada from '../../../hooks/Date/dataHoraFormatada';

pdfMake.vfs = pdfFonts.vfs;

export function gerarPDF(row) {

  console.log(row, 'verificando a linha selecionada')
  const situacaoMap = {
    0: "Aberta em dia",
    1: "Aberta em atraso",
    2: "Fechada em dia",
    3: "Fechada em atraso",
    4: "Cancelada",
  };

  const docDefinition = {
    pageMargins: [10, 10, 10, 10],
    content: [
      {
        table: {
          widths: [100, '*'],
          rowSpan: 3,
          body: [
            [
              {
                rowSpan: 3,
                text: 'Logo da\nempresa',
                alignment: 'center',
                bold: true,
                fontSize: 10,
                border: [true, true, true, true],
                margin: [0, 20],
                fillColor: '#f2f2f2',
              },
              {
                fillColor: '#f2f2f2',
                table: {
                  widths: ['*', '*', '*', '*', '*'],
                  body: [
                    [
                      { text: 'Nº O.S.', fontSize: 9, },
                      { text: row.id, fontSize: 9 },
                      { text: 'Nº S.S.', fontSize: 9 },
                      { text: '000001', fontSize: 9 },
                      { text: `Gerada em: ${dataHoraFormatada(row.created_at)}`, fontSize: 9 }
                    ],
                    [
                      { text: 'Executar em:', fontSize: 9 },
                      { text: '25/05/05 11:25', fontSize: 9 },
                      { text: 'Status:', fontSize: 9 },
                      { text: `${situacaoMap[row.situacao]}`, colSpan: 2, fontSize: 9 }, {}
                    ],
                  ]
                },
                layout: 'noBorders'
              }
            ],
            [
              {text: '', border: [false, false, false, false]},
              {
                fillColor: '#f2f2f2',
                table: {
                  widths: ['*', '*', '*', '*'],
                  borders: [false, false, false, false],
                  body: [
                    [
                      {text: 'Solicitante:', fontSize: 9},
                      {text: 'João da Silva', fontSize: 9},
                      {text: 'Tipo de manutenção:', fontSize: 9},
                      {text: row.tipo_manutencao.descricao, fontSize: 9}
                    ]
                  ]
                },
                layout: 'noBorders'
              }
            ],
            [
              {text: '', border: [false, false, false, false]},
              {
                fillColor: '#f2f2f2',
                table: {
                  widths: ['*', '*', '*', '*'],
                  body: [
                    [
                      {text: 'Executante:', fontSize: 9},
                      {text: 'Maria Oliveira', fontSize: 9},
                      {text: 'Setor Executante:', fontSize: 9},
                      {text: 'Elétrica', fontSize: 9}
                    ]
                  ]
                },
                layout: 'noBorders'
              }
            ],
            [
              { text: 'Plano', fontSize: 9, border: [true, true, true, true], fillColor: '#f2f2f2', },
              {
                fillColor: '#f2f2f2',
                table: {
                  widths: ['*', '*', '*', '*'],
                  fillColor: '#f2f2f2',
                  body: [
                    [
                      
                      { text: 'Plano Preventivo Mensal Motores Elétricos', fontSize: 9 },
                      { text: ' ', fontSize: 9 },
                      { text: 'Última Execução:', fontSize: 9 },
                      { text: '15/04/2025', fontSize: 9 }
                    ]
                  ]
                },
                layout: 'noBorders',
                border: [true, true, true, true],
                
              }
            ],
            [
              { text: 'Aplicação / Equipamento', fontSize: 9, border: [true, true, true, true], fillColor: '#f2f2f2',},
              {
                fillColor: '#f2f2f2',
                table: {
                  widths: ['*', '*', '*', '*', '*'],
                  body: [
                    [
                      { text: row.aplicacao.descricao, fontSize: 9 },
                      { text: ' ', fontSize: 9 },
                      { text: 'Garantia:', fontSize: 9 },
                      { text: 'Não', fontSize: 9 },
                      { text: '21/05/2025', fontSize: 9 }
                    ]
                  ]
                },
                layout: 'noBorders',
                border: [true, true, true, true]
              }
            ],
            [
              {
                colSpan: 2,
                text: `Solicitação:  ${row.solicitacao}`,
                fontSize: 9,
                border: [true, true, true, true],
                margin: [5, 5, 5, 50],
                fillColor: '#f2f2f2',
              },
              {}
            ],
            [
              {
                colSpan: 2,
                text: 'Observações:',
                fontSize: 9,
                border: [true, true, true, true],
                margin: [5, 5, 5, 50],
                fillColor: '#f2f2f2',
              },
              {}
            ],
            [
              {
                colSpan: 2,
                text: 'Serviços/Procedimentos',
                alignment: 'center',
                valign: 'middle',
                bold: true,
                fontSize: 10,
                margin: [0, 5, 0, 5],
                border: [true, false, true,false],
                fillColor: '#E3F2FF'
              },
              {}
            ],
            [
              {
                colSpan: 2,
                fillColor: '#E3F2FF',
                table: {
                  widths: [200, 200, 50, 89],
                  body: [
                    [
                      { text: 'Serviços', fontSize: 10, bold: true, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center',},
                      { text: 'Material', fontSize: 10, bold: true, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center',},
                      { text: 'QTDE', fontSize: 10, bold: true, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center',},
                      { text: 'Executado', fontSize: 10, bold: true, border: [false, false, false, true], margin: [5, 5, 5 ,5], alignment: 'center',},
                    ],
                    [
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: 'Sim [  ]   Não [  ]', fontSize: 9, bold: false, border: [false, false, false, true], margin: [5, 5, 5 ,5]},
                    ],
                    [
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: 'Sim [  ]   Não [  ]', fontSize: 9, bold: false, border: [false, false, false, true], margin: [5, 5, 5 ,5]},
                    ],
                    [
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: 'Sim [  ]   Não [  ]', fontSize: 9, bold: false, border: [false, false, false, true], margin: [5, 5, 5 ,5]},
                    ],
                    [
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: 'Sim [  ]   Não [  ]', fontSize: 9, bold: false, border: [false, false, false, true], margin: [5, 5, 5 ,5]},
                    ],
                    [
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: 'Sim [  ]   Não [  ]', fontSize: 9, bold: false, border: [false, false, false, true], margin: [5, 5, 5 ,5]},
                    ],
                  ]
                },
                //layout: 'noBorders',
                margin: [-5, -3, -5, -3]
              },
              {}
            ],
            [
              {
                colSpan: 2,
                text: 'Horário x Servico',
                alignment: 'center',
                valign: 'middle',
                bold: true,
                fontSize: 10,
                margin: [0, 5, 0, 5],
                border: [true, false, true,false],
                fillColor: '#E3FFEE'
              },
              {}
            ],
            [
              {
                colSpan: 2,
                fillColor: '#E3FFEE',
                table: {
                  widths: [200, 100, 100, 139],
                  body: [
                    [
                      { text: 'Executante', fontSize: 10, bold: true, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center'},
                      { text: 'Início', fontSize: 10, bold: true, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center'},
                      { text: 'Fim', fontSize: 10, bold: true, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center'},
                      { text: 'Serviços', fontSize: 10, bold: true, border: [false, false, false, true], margin: [5, 5, 5 ,5], alignment: 'center'},
                    ],
                    [
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: '     /    /         :    ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center'},
                      { text: '     /    /         :    ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center'},
                      { text: ' ', fontSize: 9, border: [false, false, false, true], margin: [5, 5, 5 ,5], alignment: 'center'}
                    ],
                    [
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: '     /    /         :    ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center'},
                      { text: '     /    /         :    ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center'},
                      { text: ' ', fontSize: 9, border: [false, false, false, true], margin: [5, 5, 5 ,5], alignment: 'center'}
                    ],
                    [
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: '     /    /         :    ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center'},
                      { text: '     /    /         :    ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center'},
                      { text: ' ', fontSize: 9, border: [false, false, false, true], margin: [5, 5, 5 ,5], alignment: 'center'}
                    ],
                    [
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: '     /    /         :    ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center'},
                      { text: '     /    /         :    ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center'},
                      { text: ' ', fontSize: 9, border: [false, false, false, true], margin: [5, 5, 5 ,5], alignment: 'center'}
                    ],
                    [
                      { text: ' ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5]},
                      { text: '     /    /         :    ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center'},
                      { text: '     /    /         :    ', fontSize: 9, border: [false, false, true, true], margin: [5, 5, 5 ,5], alignment: 'center'},
                      { text: ' ', fontSize: 9, border: [false, false, false, true], margin: [5, 5, 5 ,5], alignment: 'center'}
                    ],
                  ]
                },
                //layout: 'noBorders',
                margin: [-5, -3, -5, -3]
              },
              {}
            ],
            [
              {
                colSpan: 2,
                text: 'Validação',
                alignment: 'center',
                valign: 'middle',
                bold: true,
                fontSize: 10,
                margin: [0, 5, 0, 5],
                border: [true, false, true,false],
                fillColor: '#FFE3E3'
              },
              {} 
            ],
            [
              {
                colSpan: 2,
                alignment: 'center',
                fillColor: '#FFE3E3',
                table: {
                  widths: ['auto', 'auto', 'auto', 'auto', 'auto'],
                  body: [
                    [
                      {text: 'Assinatura do Executante', fontSize: 9, border: [false, true, false, false], alignment: 'center'},
                      {text: ' ', border: [false, false, false, false], },
                      {text: 'Assinatura do Solicitante', fontSize: 9, border: [false, true, false, false], alignment: 'center', },
                      {text: ' ', border: [false, false, false, false], },
                      {text: 'Assinatura do Responsável da Manutenção', fontSize: 9, border: [false, true, false, false], alignment: 'center', }
                    ],
                  ]
                },
                margin: [100, 20, 100, 20]
              },
              {}
            ]


          ]
        }
      }
    ]
  };

  pdfMake.createPdf(docDefinition).print();
}